var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEyeClosed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.08579 13.1966L2.5 14.6108L4.06951 13.0413L4.07205 13.0426L5.74123 11.3734L5.73909 11.3717L10.8662 6.24456L10.8679 6.24674L12.7012 4.41343L12.6989 4.41189L14.5208 2.58999L13.1066 1.17578L10.808 3.47439C9.9282 3.16727 8.98352 3.00043 8 3.00043C4.36364 3.00043 1.25818 5.2811 0 8.50043C0.515821 9.82027 1.34213 10.9823 2.38821 11.8942L1.08579 13.1966ZM4.56794 9.71445L9.23241 5.04997C8.84751 4.91004 8.43254 4.83376 8 4.83376C5.99273 4.83376 4.36364 6.47643 4.36364 8.50043C4.36364 8.92585 4.43561 9.33443 4.56794 9.71445Z",
    fill: "#333333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 14.0004C6.96429 14.0004 5.97165 13.8154 5.05249 13.4764L6.63088 11.898C7.05353 12.0715 7.51576 12.1671 8 12.1671C10.0073 12.1671 11.6364 10.5244 11.6364 8.50043C11.6364 8.02292 11.5457 7.56663 11.3808 7.14813L13.5098 5.01913C14.6042 5.94363 15.4675 7.13797 16 8.50043C14.7418 11.7198 11.6364 14.0004 8 14.0004Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeClosed);
export default __webpack_public_path__ + "static/media/eyeClosed.70f01d9f5e28db9aa342d622e493885c.svg";
export { ForwardRef as ReactComponent };